<template>

    <div class="fieldsComponent"> 
        <div class="title">Fields</div>
        <div class="checkboxes"> 
            <div class="dimensions"> 
                <div class="subTitle">Dimensions</div>
                <div v-for="(checkbox, index) in dimensionsCheckboxes" :key="index"> 
                    <div class="text"> 
                        <input name="date" type="checkbox" class="checkbox" v-bind:checked="checkbox.checked" :id="'dimension-' + index" v-model="checkbox.checked">
                        <label for="date">{{ checkbox.label.replace(/_/g, ' ').toLowerCase() }}</label>
                    </div>
                </div>
            </div>
            <div class="metrics"> 
                <div class="subTitle">Metrics</div>
                <div v-for="(checkbox, index) in metricsCheckboxes" :key="index">
                    <div class="text"> 
                        <input name="date" type="checkbox" class="checkbox" :id="'metric-' + index" :disabled="disableMetrics(checkbox.label.replace(/_/g, ' ').toLowerCase())" v-bind:checked="checkbox.checked" v-model="checkbox.checked">
                        <label for="date">{{ checkbox.label.replace(/_/g, ' ').toLowerCase() }}</label>
                    </div>
                </div>
            </div>
        </div>
        <div class="generateBtn" @click="onGenerateClick">Generate</div>
    </div>
    
</template>

<script>
export default{
    name: 'Fields',
    props: {
        dimensionFields: Object,
        metricFields: Object
    },
    data() {
        return{
            fields: []
        }
    },
    computed: {
        dimensionsCheckboxes() {
            if(this.dimensionFields){
                return Object.keys(this.dimensionFields)?.map(key => {
                    return {
                        label: key,
                        checked: this.dimensionFields[key]
                    }
                });
            }
        },
        metricsCheckboxes() {
            if(this.metricFields){
                return Object.keys(this.metricFields)?.map(key => {
                    return {
                        label: key,
                        checked: this.metricFields[key]
                    }
                });
            }
        }
    },
    methods: {
        onGenerateClick(){
            this.$emit('generateClicked', {dimensionFields: this.dimensionsCheckboxes, metricFields: this.metricsCheckboxes})
        },
        disableMetrics(value){
            if(value === 'add to cart' || value === 'pdp count' || value === 'viewable impressions'){
                return true
            }
        }

    }
}
</script>

<style scoped>

    label{
        text-transform: capitalize;
    }
    .generateBtn{
        background: #2E31BE;
        border-radius: 4px;
        padding: 12px;
        color: #FFFFFF;
        text-align: center;
        cursor: pointer;
    }

    .fieldsComponent{
        background: #FFFFFF;
        padding: 20px 24px;
        box-shadow: 3px 4px 9px rgba(0, 0, 0, 0.12);
    }
    .checkboxes{
        display: flex;
        padding-bottom: 38px;
        border-bottom: 1px solid #E0E0E0;
    }

    .dimensions{
        padding-right: 55px;
        margin-right: 16px;
    }

    .subTitle{
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 26px;
        color: #3F3F3F;
        margin-bottom: 14px;
        margin-top: 20px;
    }

    .text{
        font-weight: 400;
        font-size: 16px;
        line-height: 140%;
        color: #41434C;
        text-align: center;
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        /* margin-left: 14px; */
    }

    .title{
        font-weight: 600;
        font-size: 16px;
        line-height: 23px;
        color: rgba(0, 0, 0, 0.65);
        opacity: 0.8;
    }
</style>
